export const autoblur = node => {

	const click = e => {
		const t = e.target;
		t.closest("button, a").blur();
	};

	node.addEventListener('click', click);

	return {
		destroy() {
			node.removeEventListener('click', click);
		}
	};

};